// import retrieveAccount from '../api/account/retreiveAccountApi';
import EditAccountApi from '../api/account/editAccountApi';
import * as types from './actionTypes';
import {loadAllEstablishments} from './establishmentActions';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions'; //eslint-disable-line no-unused-vars

export function retrievedAccountFailure(resp) {
  return {type: types.USER_RETRIEVED_FAILURE, resp};
}

export function passwordResetSuccess() {
  return {type: types.PASSWORD_FORGOT_SUCCESS};
}

export function getAllEstablishments() {
  return function(dispatch) {
    dispatch(loadAllEstablishments());
  };
}

export function forgotPasswordReset(email) {
  return function (dispatch) {
    dispatch(startAjaxCall());
    return EditAccountApi.forgotPasswordReset(email)
      .then(response => {
        if(response && response.success) {
          dispatch(passwordResetSuccess());
          return true;
        } else {
          throw(Error("Could not reset password"));
        }
      })
      .catch(error => {
        dispatch(startAjaxCallError(error.message));
        dispatch(retrievedAccountFailure(error));
        throw(error);
      });
  };
}





/** WEBPACK FOOTER **
 ** ./src/actions/accountActions.js
 **/